import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// window.document.title =
//   process.env.VUE_APP_NAME + " " + process.env.VUE_APP_VERSION;

window.document.title = "Access Control System V2.2.20240708";

let routes = [
  {
    // will match everything
    path: "*",
    component: () => import("../views/404.vue")
  },
  // Authen
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/login-register",
    name: "Login Register",
    component: () => import("../views/LoginRegister.vue")
  },
  // {
  // 	path: '/login-admin',
  // 	name: 'Login Admin',
  // 	component: () => import('../views/LoginAdmin.vue'),
  // },
  // Dashboard
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard-user"
  },
  {
    path: "/dashboard-admin",
    name: "Dashboard Admin",
    layout: "dashboard",
    component: () => import("../views/DashboardAdmin.vue")
  },
  {
    path: "/dashboard-admin-system",
    name: "Dashboard Admin System",
    layout: "dashboard",
    component: () => import("../views/DashboardAdminSystem.vue")
  },
  {
    path: "/dashboard-officer",
    name: "Dashboard Officer",
    layout: "dashboard",
    component: () => import("../views/DashboardOfficer.vue")
  },
  {
    path: "/dashboard-teacher",
    name: "Dashboard Teacher",
    layout: "dashboard",
    component: () => import("../views/DashboardTeacher.vue")
  },
  {
    path: "/dashboard-user",
    name: "Dashboard User",
    layout: "dashboard",
    component: () => import("../views/DashboardUser.vue")
  },
  // Booking
  {
    path: "/booking",
    name: "Booking",
    layout: "dashboard",
    component: () => import("../views/Booking/Booking.vue")
  },
  // Data
  {
    path: "/users",
    name: "Users",
    layout: "dashboard",
    component: () => import("../views/Data/Users.vue")
  },
  {
    path: "/guests",
    name: "Guests",
    layout: "dashboard",
    component: () => import("../views/Data/Guests.vue")
  },
  {
    path: "/rooms",
    name: "Rooms",
    layout: "dashboard",
    component: () => import("../views/Data/Rooms.vue")
  },
  {
    path: "/buildings",
    name: "Buildings",
    layout: "dashboard",
    component: () => import("../views/Data/Buildings.vue")
  },
  {
    path: "/group-attendees",
    name: "Group Attendees",
    layout: "dashboard",
    component: () => import("../views/Data/GroupAttendees.vue")
  },
  {
    path: "/group-whitelists",
    name: "Group Whitelists",
    layout: "dashboard",
    component: () => import("../views/Data/GroupWhitelists.vue")
  },
  {
    path: "/mcus",
    name: "MCUs",
    layout: "dashboard",
    component: () => import("../views/Data/Mcus.vue")
  },
  // Report
  {
    path: "/roomReport",
    name: "Room Report",
    layout: "dashboard",
    component: () => import("../views/Report/RoomReport.vue")
  },
  {
    path: "/roominfo/:id",
    name: "Room Info",
    layout: "dashboard",
    component: () => import("../views/Data/RoomInfo.vue")
  },
  {
    path: "/userReport",
    name: "User Report",
    layout: "dashboard",
    component: () => import("../views/Report/UserReport.vue")
  },
  {
    path: "/userinfo/:id",
    name: "User Info",
    layout: "dashboard",
    component: () => import("../views/Data/UserInfo.vue")
  },
  {
    path: "/logReport",
    name: "Log Report",
    layout: "dashboard",
    component: () => import("../views/Report/LogReport.vue")
  },
  // Setting
  {
    path: "/adminsSetting",
    name: "Admins",
    layout: "dashboard",
    component: () => import("../views/Setting/Admins.vue")
  },
  //
  // User
  //
  {
    path: "/my-info",
    name: "Info",
    layout: "dashboard",
    component: () => import("../views/MyInfo.vue")
  }
];

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
  route.meta = route.meta || {};
  route.meta.layout = route.layout || parentLayout;

  if (route.children) {
    route.children = route.children.map(childRoute =>
      addLayoutToRoute(childRoute, route.meta.layout)
    );
  }
  return route;
}

routes = routes.map(route => addLayoutToRoute(route));

const router = new VueRouter({
  mode: "hash",
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth"
      };
    }
    return {
      x: 0,
      y: 0,
      behavior: "smooth"
    };
  }
});

export default router;
